<app-card-offer
  [data]="data"
  [type]="type"
  [index]="index"
  [continueLoading]="btn_retomar_aplicacion"
  [ratingResult]="ratingResultState"
  (applyPressed)="applyOffer()"
  (detailPressed)="openOfferDetail()"
  (retryPressed)="redirect()"
  (continuePressed)="continueApply()"
  (ratingSubmitted)="sendOfferCali($event)"
  (clearPreselecta)="clearDataPreselecta()"
  (alertClosed)="ratingResultState = 'none'">
</app-card-offer>
